import { Dialog, DialogProps, Slide, styled } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { FC, PropsWithChildren, forwardRef } from 'react'

import Context from './Context'

export { default as ModalHeader } from './ModalHeader'
export { default as ModalBody } from './ModalBody'
export { default as ModalFooter } from './ModalFooter'

export interface ModalProps
  extends Pick<
    DialogProps,
    'keepMounted' | 'fullWidth' | 'maxWidth' | 'open' | 'PaperProps' | 'sx'
  > {
  onClose: (reason?: 'backdropClick' | 'escapeKeyDown') => void
}

const Modal: FC<PropsWithChildren<ModalProps>> = ({
  children,
  fullWidth,
  keepMounted,
  maxWidth,
  open,
  PaperProps,
  sx,
  onClose,
}) => {
  return (
    <Context.Provider value={{ onClose }}>
      <StyledDialog
        fullWidth={fullWidth}
        keepMounted={keepMounted}
        maxWidth={maxWidth}
        open={open}
        PaperProps={PaperProps}
        sx={sx}
        TransitionComponent={Transition}
        onClose={onClose}
      >
        {children}
      </StyledDialog>
    </Context.Provider>
  )
}

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

const StyledDialog = styled(Dialog)`
  backdrop-filter: blur(3px);
  & .MuiPaper-root {
    border-radius: ${({ theme }) => theme.spacing(2)};
  }
`

export default Modal
